import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/home/index.vue')
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: () => import('@/views/aboutUs/index.vue')
    },
    {
      path: '/customDev',
      name: 'customDev',
      component: () => import('@/views/customDev/index.vue')
    },
    {
      path: '/customerCase',
      name: 'customerCase',
      component: () => import('@/views/customerCase/index.vue')
    },
    {
      path: '/customerCaseDetails',
      name: 'customerCaseDetails',
      component: () => import('@/views/customerCase/customerCaseDetails.vue')
    },
  ]
})

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};



// WEBPACK FOOTER //
// ./src/router/index.js